import { IIndividuals } from "./models";

export const sex = [
  { id: "1", name: "Homem" },
  { id: "2", name: "Mulher" },
];

export const age = [
  { id: "1", name: "De 0 a 10 anos" },
  { id: "2", name: "De 11 a 20 anos" },
  { id: "3", name: "De 21 a 30 anos" },
  { id: "4", name: "De 31 a 40 anos" },
  { id: "5", name: "De 41 a 50 anos" },
  { id: "6", name: "De 51 a 60 anos" },
  { id: "7", name: "Mais de 60 anos" },
];

export const individualItems: IIndividuals[] = [
  {
    id: "1",
    sex: sex[0],
    age: age[0],
  },
  {
    id: "2",
    sex: sex[1],
    age: age[1],
  },
];
